export enum MeetingScope {
  Internal = 'Internal',

  External = 'External',
}
